import * as R from 'ramda';
import { OrderProduct, Section } from '../../orderProducts.types';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByProduct extends OrderProductsBuilder {
  public group({ orderProducts }: OrderProductsGroupProps): Section[] {
    const groupedProducts = R.groupBy<OrderProduct>((product) => product.code || '', orderProducts);

    const groupedProductsToPairs = R.toPairs(groupedProducts);

    return groupedProductsToPairs.map((items) => {
      const products = items[1]!;
      const { code, name } = products[0];
      return {
        productTitle: `${name} - ${code}`,
        productsCount: products.length,
        isExpanded: true,
        products,
      };
    });
  }
}

export default OrderProductsGroupByProduct;
